import { MenuItem, Stack } from '@chakra-ui/react';
import { t } from '@transifex/native';
import { FC, useState } from 'react';
import { credentials } from '../../../@xmcloud/core/messages/en';
import { useSharedState } from '../../../@xmcloud/hooks';
import { IS_SM_SCREEN } from '../../../@xmcloud/hooks/context/useSharedState';
import { Footer, XMCSButton, XMCSMenuButton } from '../../shared-components';
import CreateCredentials from './components/CreateCredentials';
import EnvironmentCredentialsTable from './components/EnvironmentCredentialsTable';
import CreateCMAutomationClient from './CreateCMAutomationClient';
import CreateEdgeAdministrationClient from './CreateEdgeAdministrationClient';
import CreateEhBuildClient from './CreateEhBuildClient';
import { useFeature } from 'app/feature-flag/features';

export const EnvironmentCredentials: FC = () => {
	const [openAutomationModal, setOpenAutomationModal] = useState(false);
	const [openEdgeModal, setOpenEdgeModal] = useState(false);
	const [openEHModal, setOpenEHModal] = useState(false);
	const { state: isSmScreen } = useSharedState(IS_SM_SCREEN, false);
	const [createCredentialsModal, setCreateCredentialsModal] = useState(false);
	const showEH = useFeature('EnableExternalEH');

	return (
		<>
			<Stack
				direction="row"
				justify="flex-end"
				mt={6}
				mb={isSmScreen ? 0 : 5}
			>
				{!isSmScreen && (
					<nav aria-label={t(credentials.create)}>
						<XMCSMenuButton
							text={credentials.create}
							data-testid="menu-button"
						>
							<MenuItem
								onClick={() => setOpenEdgeModal(true)}
								data-testid="menu-item-edge"
							>
								{t(credentials.edge)}
							</MenuItem>
							<MenuItem
								onClick={() => setOpenAutomationModal(true)}
								data-testid="menu-item-automation"
							>
								{t(credentials.automation)}
							</MenuItem>
							{showEH && (
								<MenuItem
									onClick={() => setOpenEHModal(true)}
									data-testid="menu-item-externalEditingHost"
								>
									{t(credentials.externalEditingHost)}
								</MenuItem>
							)}
						</XMCSMenuButton>
					</nav>
				)}
			</Stack>

			<EnvironmentCredentialsTable />
			{Boolean(isSmScreen) && (
				<Footer>
					<XMCSButton
						text={credentials.create}
						data-testid="create-credentials-button"
						onClick={() => setCreateCredentialsModal(true)}
					/>
				</Footer>
			)}
			{openAutomationModal && (
				<CreateCMAutomationClient
					openModal={openAutomationModal}
					setOpenModal={setOpenAutomationModal}
				/>
			)}
			{openEdgeModal && (
				<CreateEdgeAdministrationClient
					openModal={openEdgeModal}
					setOpenModal={setOpenEdgeModal}
				/>
			)}
			{openEHModal && (
				<CreateEhBuildClient
					openModal={openEHModal}
					setOpenModal={setOpenEHModal}
				/>
			)}
			{createCredentialsModal && (
				<CreateCredentials
					{...{
						isOpen: createCredentialsModal,
						setIsOpenOpen: setCreateCredentialsModal,
						setOpenEdgeModal,
						setOpenAutomationModal,
						setOpenEHModal,
					}}
				/>
			)}
		</>
	);
};
